var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "mt-4 w-100" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center justify-content-xxl-start" },
        [
          _c(
            "b-col",
            _vm._b(
              {
                staticClass:
                  "img-checkbox d-flex align-items-center flex-column",
              },
              "b-col",
              _vm.colOptions.flows,
              false
            ),
            [
              _c("input", {
                attrs: {
                  id: "includeSendApplication",
                  type: "checkbox",
                  name: "includeSendApplication",
                  disabled: _vm.readOnly,
                },
                domProps: { checked: _vm.includeSendApplication },
                on: { change: _vm.handleApplicationChange },
              }),
              _vm._v(" "),
              _c("img", {
                class: _vm.readOnly ? "small" : "big",
                attrs: {
                  src: require("@Shared/@Assets/img/complete-application.png"),
                  alt: _vm.$t(
                    "request-package.chooseFlow.inviteClienttoCompleteApplication"
                  ),
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  class: { "inside-box": !_vm.readOnly },
                  attrs: { for: "includeSendApplication" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "request-package.chooseFlow.inviteClienttoCompleteApplication"
                      )
                    )
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            _vm._b(
              {
                staticClass:
                  "img-checkbox d-flex align-items-center flex-column",
              },
              "b-col",
              _vm.colOptions.flows,
              false
            ),
            [
              _c("input", {
                attrs: {
                  id: "includeBankStatements",
                  type: "checkbox",
                  name: "includeBankStatements",
                  disabled: _vm.readOnly,
                },
                domProps: { checked: _vm.includeBankStatements },
                on: { change: _vm.handleBankStatementsChange },
              }),
              _vm._v(" "),
              _c("img", {
                class: _vm.readOnly ? "small" : "big",
                attrs: {
                  src: require("@Shared/@Assets/img/bank-statements.png"),
                  alt: "$t('request-package.steps.requestBankStatements')",
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  class: { "inside-box": !_vm.readOnly },
                  attrs: { for: "includeBankStatements" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("request-package.steps.requestBankStatements")
                    )
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.includeBankStatements | _vm.includeSendApplication
            ? _c(
                "b-col",
                {
                  staticClass:
                    "d-flex justify-content-center flex-column slide-up mt-2",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        _vm._b(
                          { staticClass: "mb-3" },
                          "b-col",
                          _vm.colOptions.options,
                          false
                        ),
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "automations.requestPackage.sendOptions"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass:
                                "form-group-material-no-label radio-form-transparent",
                            },
                            [
                              _c("radio-section", {
                                attrs: {
                                  name: _vm.radioId,
                                  options: _vm.coApplicantsSendOptions,
                                  checked: _vm.selectedOption,
                                  disabled: _vm.readOnly,
                                  "container-class": "w-auto",
                                  "option-class": "h-auto",
                                },
                                on: { change: _vm.handleOptionChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        _vm._b(
                          { staticClass: "mb-3" },
                          "b-col",
                          _vm.colOptions.options,
                          false
                        ),
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("application-flow.labels.mortgageType")
                                ) +
                                ":\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "automations.requestPackage.createApplication" +
                                      (_vm.isCreate
                                        ? "ForClientProfile"
                                        : "IfNone")
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass:
                                "form-group-material-no-label radio-form-transparent",
                            },
                            [
                              _c("radio-section", {
                                attrs: {
                                  name: _vm.radioFlowId,
                                  options: _vm.flowsColumns,
                                  checked: _vm.applicationFlow,
                                  disabled: _vm.readOnly,
                                  "container-class": "w-auto",
                                  "option-class": "h-auto",
                                },
                                on: { change: _vm.handleApplicationTypeChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.readOnly ||
          _vm.includeBankStatements ||
          _vm.includeSendApplication
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("request-package.customizeMessage.subtitle")
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.readOnly
                    ? _c("automation-email-read-only", {
                        staticClass: "mt-3",
                        attrs: {
                          value: { body: _vm.userMessage },
                          "show-content-title": false,
                        },
                      })
                    : _c(
                        "b-row",
                        { staticClass: "slide-up automation-package mt-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", sm: "8" } },
                            [
                              _c("email-editor", {
                                ref: "emailEditor",
                                attrs: {
                                  "email-body": _vm.userMessage,
                                  height: "10vw",
                                  "show-merge-tags": true,
                                  "substitution-hints": true,
                                  attachments: false,
                                  "show-application-merge-tags": false,
                                },
                                on: { change: _vm.handleEditorChange },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "side-controls",
                              attrs: { cols: "12", sm: "4" },
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "automations.emailEditorSubstitutions"
                                        )
                                      ) +
                                      ":\n              "
                                  ),
                                  _c(
                                    "ul",
                                    { staticClass: "email-tags" },
                                    _vm._l(_vm.tags, function (tag) {
                                      return _c("li", { key: tag }, [
                                        _c("button", {
                                          staticClass: "clickable",
                                          domProps: {
                                            textContent: _vm._s(tag),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleTag(tag)
                                            },
                                          },
                                        }),
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "automations.clickingWillInsertSubstitutions"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }